/* jshint ignore:start */
if (typeof define !== 'function') {
    var define = require('amdefine')(module)
}
/* jshint ignore:end */

define('pdfGear/generator/footer',['../localization/labels', './components'], function(labels, components) {
    'use strict';

    return {
        getFooter: getFooter
    };

    /**
     * Function to create footer for the pdf from the given data
     * @param  input data to be used for making the footer
     * @return array of javascript objects according to the pdfmake format
     */
    function getFooter(inputData) {
        return function(currentPage) {
            return [
                components.getHorizontalLine([20, 0, 20, 10]), {
                    text: inputData.reportTitle,
                    alignment: 'left',
                    margin: [40, 0, 0, 0],
                    fontSize: 8
                }, {
                    text: labels.footer.orgName + inputData.brandName,
                    alignment: 'center',
                    margin: [0, -12, 0, 0],
                    fontSize: 8
                }, {
                    text: currentPage.toString(),
                    alignment: 'right',
                    margin: [0, -12, 40, 0],
                    fontSize: 8
                }
            ];
        };
    }
});
